import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/shared/components/ui/dialog'
import { Skeleton } from '@/shared/components/ui/skeleton'
import { useCampaniaHtml } from '@/modules/multichannel/hooks/useCampanias'

interface HtmlPreviewModalProps {
  campaniaId: number | null
  nombre: string
  open: boolean
  onClose: () => void
}

export function HtmlPreviewModal({ campaniaId, nombre, open, onClose }: HtmlPreviewModalProps) {
  const { data, isLoading } = useCampaniaHtml(open ? campaniaId : null)

  return (
    <Dialog open={open} onOpenChange={(isOpen) => !isOpen && onClose()}>
      <DialogContent className="max-w-4xl max-h-[85vh] flex flex-col">
        <DialogHeader>
          <DialogTitle className="truncate">Vista Previa - {nombre}</DialogTitle>
        </DialogHeader>
        <div className="flex-1 overflow-hidden rounded-md border border-gray-200 dark:border-gray-700">
          {isLoading ? (
            <div className="p-4 space-y-3">
              <Skeleton className="h-6 w-3/4" />
              <Skeleton className="h-40 w-full" />
              <Skeleton className="h-4 w-1/2" />
            </div>
          ) : data?.contenido_html ? (
            <iframe
              srcDoc={data.contenido_html}
              sandbox="allow-same-origin allow-popups allow-popups-to-escape-sandbox"
              className="w-full h-[65vh] border-0"
              title={`Preview de ${nombre}`}
            />
          ) : (
            <div className="flex items-center justify-center h-40 text-muted-foreground text-sm">
              No hay contenido HTML para mostrar
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  )
}
